module.exports = __webpack_public_path__ + "static/popper-logo-394b4ea5914aad7fc580f418ed0cfb17.svg";